// extracted by mini-css-extract-plugin
export default {"neutral":"FileStatusBadge_neutral__1iOO-"};